import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55a691f7")

_pushScopeId("data-v-55a691f7")
const _hoisted_1 = {
  class: "tickets-doing",
  id: "tickets-doing"
}
const _hoisted_2 = { class: "ticket-title" }
const _hoisted_3 = {
  key: 0,
  class: "warning"
}
const _hoisted_4 = {
  key: 1,
  class: "timeout"
}
const _hoisted_5 = {
  key: 0,
  class: "pagination-wrap"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TicketViewSearchForm = _resolveComponent("TicketViewSearchForm")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_TicketViewSearchForm, { submit: _ctx.ticketViewSearchFormSubmit }, null, 8, ["submit"]),
    _withDirectives(_createVNode(_component_el_table, {
      border: "",
      class: "ticket-table",
      data: _ctx.tableData,
      style: {"width":"100%"},
      "default-sort": _ctx.orderField,
      onSortChange: _ctx.sortChange
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          width: "60",
          label: "编号"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, [
              _createVNode(_component_router_link, {
                to: {
              name: '工单详情',
              params: {
                id: scope.row.id
              }
            }
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(scope.row.id), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题",
          width: "180"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.$router.push({
              name: '工单详情',
              params: {
                id: scope.row.id
              }
            })),
                class: "title"
              }, _toDisplayString(scope.row.title), 9, ["onClick"]),
              (scope.row.warning)
                ? (_openBlock(), _createBlock("span", _hoisted_3, "超时预警"))
                : _createCommentVNode("", true),
              (scope.row.timeout)
                ? (_openBlock(), _createBlock("span", _hoisted_4, "已超时"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        }, {
          default: _withId((scope) => [
            (scope.row.desc)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withId(() => [
                    _createVNode("div", {
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  default: _withId(() => [
                    _createVNode("div", {
                      class: "ticket-desc",
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "curPhase",
          width: "90",
          label: "阶段",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          prop: "urgentLevel",
          width: "110",
          label: "紧急程度",
          sortable: "custom",
          formatter: _ctx.priorityFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          sortable: "custom",
          width: "120",
          formatter: _ctx.createTimeFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "updateTime",
          label: "更新时间",
          width: "120",
          formatter: _ctx.updateTimeFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "responsibleAgentName",
          width: "150",
          label: "处理人"
        })
      ]),
      _: 1
    }, 8, ["data", "default-sort", "onSortChange"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.total)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _ctx.pageSize,
            layout: "prev, pager, next, sizes, jumper, total",
            total: _ctx.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true)
  ]))
})